module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title title-rntrc"
  }, [_vm._v("RNTRC")]), _vm._v(" "), (false) ? _c('router-link', {
    staticClass: "btn btn-primary btn-new-plan",
    attrs: {
      "tag": "button",
      "to": {
        name: 'new-contract'
      }
    }
  }, [_c('i', {
    staticClass: "icon-plus icon-plus-plan align-icon-right-sm"
  }), _vm._v("\n        Nova Vinculação\n      ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "min-content"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "bold"
  }, [_vm._v("Vincular veículos")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "well-rntrc"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label-company"
  }, [_c('h4', {
    staticClass: "label-company-name"
  }, [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "label-cnpj"
  }, [_c('b', [_vm._v("CNPJ:")]), _vm._v(" " + _vm._s(_vm._f("cpfCnpj")(_vm.user.taxIdNumber)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "label-rntrc"
  }, [_c('b', [_vm._v("RNTRC:")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editRntrc),
      expression: "!editRntrc"
    }],
    staticClass: "force-link",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Editar o código RNTRC"
    },
    on: {
      "click": function($event) {
        return _vm.startEditRntrc()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.rntrc) + " "), _c('i', {
    staticClass: "icon-pencil icon-edit"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editRntrc),
      expression: "editRntrc"
    }],
    staticClass: "editable"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRntrc),
      expression: "newRntrc"
    }],
    staticClass: "form-control rntrc-label-input",
    attrs: {
      "name": "name",
      "placeholder": "00000000"
    },
    domProps: {
      "value": (_vm.newRntrc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newRntrc = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rntrc-box-edit"
  }), _vm._v(" "), _c('div', {
    staticClass: "inline",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Cancelar edição"
    },
    on: {
      "click": function($event) {
        return _vm.cancelEditRntrc()
      }
    }
  }, [_c('i', {
    staticClass: "icon-cancel-edit"
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Salvar edição"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEditRntrc()
      }
    }
  }, [_c('i', {
    staticClass: "icon-check-edit"
  })])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), (false) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n      Não há TAGs para vincular no momento.\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle, index) {
    return _c('vehicle-rntrc', {
      key: vehicle.vehicleId,
      attrs: {
        "vehicle": vehicle,
        "rntrc": _vm.rntrc
      }
    })
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v("\n          A vinculação do Registro Nacional de Transportadores de Cargas (RNTRC) a um dispositivo eletrônico (TAG) tornou-se obrigatória pela ANTT. Se você é um transportador e ainda não possui um TAG vinculado, adquira já!\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 margin-b10 margin-t20"
  }, [_vm._v("\n        Para vincular os veículos ao seu RNTRC é necessário informar os dados abaixo, clicar em vincular e pronto!\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-33c50a11!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/rntrc/rntrc-vinculation.vue
// module id = 2088
// module chunks = 1